module.exports = __webpack_public_path__ + "img/house_marker.9f3a438d.png";